var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('h3',{staticClass:"centre"},[_vm._v("Payment "+_vm._s(_vm.result)+", redirecting to order detail...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }